import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from '../hooks/useSoundEffects';
import { EXPLORE_UNKNOWN_EP_METERS } from '../config/exploreUnknownEmergencyProtocol';
import '../BattleUIExploreUnknownDarknessFlash.css';

/**
 * @param {{
 *   popupId: string,
 *   epBonusId: string,
 *   partsCollected: number,
 *   targetParts: number,
 *   setCompleted: boolean,
 *   newCharges?: number,
 *   onDismiss: () => void,
 * }} props
 */
export default function ExploreUnknownEpFragmentMapProcModal({
  popupId,
  epBonusId,
  partsCollected,
  targetParts,
  setCompleted,
  newCharges,
  onDismiss,
}) {
  const { t } = useTranslation();
  const meter = EXPLORE_UNKNOWN_EP_METERS.find((m) => m.id === epBonusId);
  if (!meter) {
    throw new Error(`ExploreUnknownEpFragmentMapProcModal: unknown epBonusId "${String(epBonusId)}"`);
  }

  useEffect(() => {
    playSoundEffect('/sounds/legendary_reveal.mp3');
  }, [popupId]);

  const bodyKey = setCompleted
    ? 'exploreUnknownBattle.epFragmentMapProcSetCompleteBody'
    : 'exploreUnknownBattle.epFragmentMapProcBody';

  return createPortal(
    <div className="battle-eu-heart-set-complete-overlay explore-unknown-reward-popup-overlay" onClick={onDismiss}>
      <div
        className={`battle-eu-heart-set-complete-modal battle-eu-heart-set-complete-modal--${meter.variant} explore-unknown-reward-popup-modal`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="explore-unknown-ep-fragment-map-proc-title"
      >
        <h3 id="explore-unknown-ep-fragment-map-proc-title" className="battle-eu-heart-set-complete-title">
          {t('exploreUnknownBattle.epFragmentMapProcTitle')}
        </h3>
        <div className="battle-eu-heart-set-complete-visual">
          <img src={meter.image} alt="" className="battle-eu-heart-set-complete-image" />
        </div>
        <p className="battle-eu-heart-set-complete-body">
          {t(bodyKey, {
            partsCollected,
            targetParts,
            charges: newCharges ?? 0,
            epName: t(`exploreUnknownBattle.${meter.i18nKey}SetCompleteTitle`, {
              defaultValue: meter.id,
            }),
          })}
        </p>
        <button type="button" className="battle-eu-heart-set-complete-ok" onClick={onDismiss}>
          {t('exploreUnknownBattle.epFragmentMapProcOk')}
        </button>
      </div>
    </div>,
    document.body
  );
}
